<mat-toolbar style="min-height: 40px; max-height: 40px;">

    <span fxFlex></span>
    <span class="f-s-12 p-r-16">Oregon Health Authority</span>
    <span class="f-s-12 p-r-16">Public Health Division</span>
    <span class="f-s-12 p-r-16">Oregon Environmental Public Health</span>
    <span class="f-s-12">{{environment.build}} Version {{environment.version}}</span>
  
</mat-toolbar>
